import React from 'react';
import PropTypes from 'prop-types';
import { DaButton } from '@paygreen/paygreen-ui';
import IconByName from '../../utils/IconByName';

const ValidateButton = ({
    buttonSize,
    children,
    icon,
    onClick,
    type,
    dataCy,
    ...rest
}) => (
    <button type={type} onClick={onClick} data-cy={dataCy}>
        <DaButton
            buttonSize={buttonSize}
            colorPallet="status"
            colorStatus="success"
            icon={<IconByName name={icon} />}
            {...rest}
        >
            {children}
        </DaButton>
    </button>
);

ValidateButton.propTypes = {
    onClick: PropTypes.func,
    buttonSize: PropTypes.string,
    icon: PropTypes.string,
    type: PropTypes.string,
};

ValidateButton.defaultProps = {
    buttonSize: 'sm',
    icon: 'CheckIcon',
    type: 'submit',
};

export default ValidateButton;
